<mat-card>
  <div class="video-container">
    <video [src]="video.videoURI" controls poster="/assets/play-thumb.jpg"></video>
  </div>
  <mat-card-content>
    <h4>{{video.title}}</h4>
    <p>{{video.description}}</p>
  </mat-card-content>
</mat-card>
